import { render } from "./PassingTable.vue?vue&type=template&id=5afc5876&scoped=true"
import script from "./PassingTable.vue?vue&type=script&lang=js"
export * from "./PassingTable.vue?vue&type=script&lang=js"

import "./PassingTable.vue?vue&type=style&index=0&id=5afc5876&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5afc5876"]])

export default __exports__